import { COMPANY } from './company.data';

export const PRIVACY_DOC = {
  title: 'Política de Privacidade',
  subtitle: 'Como tratamos os seus dados pessoais',
  lastUpdated: COMPANY.lastUpdated,
  sections: [
    {
      title: 'Quem é o controlador dos seus dados',
      blocks: [
        {
          type: 'p',
          text:
            `Esta Política de Privacidade descreve como a ${COMPANY.legalName}, inscrita no CNPJ nº ` +
            `${COMPANY.cnpj}, com sede em ${COMPANY.address} ("${COMPANY.tradeName}", "nós"), coleta, ` +
            `utiliza, compartilha e protege os dados pessoais dos usuários do site ${COMPANY.domain}.`,
        },
        {
          type: 'p',
          text:
            'O tratamento de dados é realizado em conformidade com a Lei Geral de Proteção de Dados ' +
            '(Lei nº 13.709/2018 – "LGPD") e demais normas aplicáveis. Ao utilizar a plataforma, você ' +
            'declara estar ciente das práticas descritas nesta Política.',
        },
      ],
    },
    {
      title: 'Definições importantes',
      blocks: [
        {
          type: 'list',
          items: [
            'Dado pessoal: informação relacionada a pessoa natural identificada ou identificável (ex.: nome, CPF, e-mail);',
            'Titular: a pessoa a quem os dados pessoais se referem — no caso, você;',
            'Controlador: quem decide sobre o tratamento dos dados (a Assegurados);',
            'Operador: quem trata dados em nome do controlador (ex.: provedores de tecnologia);',
            'Tratamento: qualquer operação com dados, como coleta, uso, armazenamento e compartilhamento.',
          ],
        },
      ],
    },
    {
      title: 'Quais dados coletamos',
      blocks: [
        { type: 'subheading', text: 'a) Dados que você nos fornece' },
        {
          type: 'list',
          items: [
            'Dados do comprador: nome completo, CPF, sexo, data de nascimento, e-mail, telefone, CEP e endereço;',
            'Dados dos passageiros/segurados: nome completo, CPF, sexo, data de nascimento, e-mail e telefone/WhatsApp;',
            'Dados da viagem: datas de embarque e desembarque, destino e idade dos passageiros;',
            'Dados de pagamento: informações do cartão (número, nome do titular, CPF, validade, bandeira e código de segurança) ou dados para pagamento via PIX.',
          ],
        },
        { type: 'subheading', text: 'b) Dados coletados automaticamente' },
        {
          type: 'list',
          items: [
            'Dados de navegação e dispositivo, como endereço IP, tipo de navegador e páginas acessadas;',
            'Cookies e identificadores utilizados para o funcionamento e a melhoria da plataforma.',
          ],
        },
        { type: 'subheading', text: 'c) Dados sensíveis' },
        {
          type: 'p',
          text:
            'A plataforma não coleta intencionalmente dados pessoais sensíveis (como informações de saúde). ' +
            'Caso a contratação de determinada cobertura exija informações de saúde (por exemplo, cobertura ' +
            'para doenças preexistentes), esses dados são fornecidos e tratados diretamente pela seguradora ' +
            'responsável, conforme as políticas dela.',
        },
      ],
    },
    {
      title: 'Para que usamos os seus dados e com qual base legal',
      blocks: [
        {
          type: 'p',
          text: 'Tratamos os seus dados pessoais para as seguintes finalidades:',
        },
        {
          type: 'list',
          items: [
            'Executar a cotação e a contratação do seguro viagem, encaminhando os dados à seguradora escolhida — base legal: execução de contrato (art. 7º, V, da LGPD);',
            'Processar o pagamento da compra — base legal: execução de contrato;',
            'Cumprir obrigações legais, regulatórias e fiscais — base legal: cumprimento de obrigação legal (art. 7º, II);',
            'Prestar atendimento e suporte ao usuário — base legal: execução de contrato e legítimo interesse (art. 7º, IX);',
            'Melhorar a plataforma, prevenir fraudes e garantir a segurança — base legal: legítimo interesse;',
            'Enviar comunicações e ofertas, quando autorizado — base legal: consentimento (art. 7º, I).',
          ],
        },
      ],
    },
    {
      title: 'Com quem compartilhamos os seus dados',
      blocks: [
        {
          type: 'p',
          text:
            'Não vendemos seus dados pessoais. Compartilhamos dados apenas na medida necessária para prestar ' +
            'o serviço, com as seguintes categorias de destinatários:',
        },
        {
          type: 'list',
          items: [
            'Seguradoras e empresas de assistência parceiras (Assist Card, Universal Assistance, Affinity e outras), para emissão da apólice e prestação do seguro;',
            'Meios e processadores de pagamento, para efetivar a transação;',
            'Provedores de tecnologia que operam em nosso nome, como Google Firebase (autenticação, banco de dados, hospedagem e análise), Sentry (monitoramento de erros) e serviços de consulta de endereço por CEP (ViaCEP);',
            'Autoridades públicas e órgãos reguladores, quando exigido por lei ou ordem judicial.',
          ],
        },
        {
          type: 'p',
          text:
            'Os dados fornecidos às seguradoras passam a ser tratados também por elas, na condição de ' +
            'controladoras, conforme as respectivas políticas de privacidade.',
        },
      ],
    },
    {
      title: 'Dados de pagamento',
      blocks: [
        {
          type: 'p',
          text:
            'Os dados de pagamento são utilizados exclusivamente para processar a transação junto à ' +
            'seguradora e/ou ao meio de pagamento responsável pela cobrança. Adotamos medidas técnicas para ' +
            'proteger essas informações e não as utilizamos para finalidades diversas da contratação.',
        },
      ],
    },
    {
      title: 'Transferência internacional de dados',
      blocks: [
        {
          type: 'p',
          text:
            'Alguns parceiros e provedores de tecnologia podem armazenar ou processar dados em servidores ' +
            'localizados fora do Brasil. Nesses casos, adotamos as salvaguardas previstas na LGPD para ' +
            'garantir a proteção dos seus dados.',
        },
      ],
    },
    {
      title: 'Cookies e tecnologias de rastreamento',
      blocks: [
        {
          type: 'p',
          text:
            'Utilizamos cookies e tecnologias semelhantes para permitir o funcionamento da plataforma, ' +
            'lembrar preferências, medir o desempenho e melhorar sua experiência. Você pode gerenciar ou ' +
            'bloquear cookies nas configurações do seu navegador, ciente de que isso pode afetar algumas ' +
            'funcionalidades do site.',
        },
      ],
    },
    {
      title: 'Registro de atividades e logs de acesso',
      blocks: [
        {
          type: 'p',
          text:
            'Em cumprimento ao Marco Civil da Internet (Lei nº 12.965/2014), podemos manter registros de ' +
            'acesso e de atividades na plataforma — como endereço IP, data e hora de conexão e páginas ' +
            'acessadas. Esses registros ajudam a garantir a segurança, prevenir fraudes e cumprir obrigações ' +
            'legais, e são armazenados pelos prazos previstos na legislação.',
        },
      ],
    },
    {
      title: 'Por quanto tempo guardamos os seus dados',
      blocks: [
        {
          type: 'p',
          text:
            'Mantemos os dados pessoais pelo tempo necessário para cumprir as finalidades descritas nesta ' +
            'Política e para atender a obrigações legais, regulatórias, contábeis e fiscais, bem como para o ' +
            'exercício regular de direitos. Findos esses prazos, os dados são eliminados ou anonimizados.',
        },
      ],
    },
    {
      title: 'Segurança da informação',
      blocks: [
        {
          type: 'p',
          text:
            'Adotamos medidas técnicas e organizacionais para proteger os dados pessoais contra acessos não ' +
            'autorizados, perda, alteração ou divulgação indevida. Apesar dos nossos esforços, nenhum sistema ' +
            'é totalmente imune a incidentes; caso ocorra um incidente relevante, adotaremos as providências ' +
            'exigidas pela LGPD.',
        },
      ],
    },
    {
      title: 'Seus direitos como titular',
      blocks: [
        {
          type: 'p',
          text: 'Nos termos da LGPD, você pode, a qualquer momento, solicitar:',
        },
        {
          type: 'list',
          items: [
            'A confirmação da existência de tratamento e o acesso aos seus dados;',
            'A correção de dados incompletos, inexatos ou desatualizados;',
            'A anonimização, bloqueio ou eliminação de dados desnecessários ou tratados em desconformidade com a lei;',
            'A portabilidade dos dados a outro fornecedor, quando aplicável;',
            'A eliminação dos dados tratados com base no seu consentimento;',
            'Informações sobre com quem compartilhamos seus dados;',
            'A revogação do consentimento, quando esta for a base legal utilizada.',
          ],
        },
        {
          type: 'p',
          text:
            `Para exercer seus direitos, entre em contato pelo e-mail ${COMPANY.privacyEmail}. ` +
            'Poderemos solicitar informações adicionais para confirmar a sua identidade antes de atender ao pedido.',
        },
      ],
    },
    {
      title: 'Tratamento de dados de crianças e adolescentes',
      blocks: [
        {
          type: 'p',
          text:
            'A plataforma é destinada a maiores de 18 anos. Dados de menores só são tratados quando fornecidos ' +
            'pelos pais ou responsáveis legais, no interesse do menor, para fins de contratação do seguro ' +
            'viagem, conforme a legislação aplicável.',
        },
      ],
    },
    {
      title: 'Encarregado e canal de contato',
      blocks: [
        {
          type: 'p',
          text:
            'Para tratar de assuntos relacionados a dados pessoais e a esta Política, disponibilizamos o ' +
            `canal ${COMPANY.privacyEmail}. Também é possível falar conosco pelo WhatsApp ${COMPANY.supportWhatsapp}.`,
        },
      ],
    },
    {
      title: 'Alterações desta Política',
      blocks: [
        {
          type: 'p',
          text:
            'Esta Política pode ser atualizada a qualquer momento. A versão vigente estará sempre disponível ' +
            'nesta página, com a data da última atualização indicada no topo. Recomendamos a consulta periódica.',
        },
      ],
    },
    {
      title: 'Legislação aplicável e foro',
      blocks: [
        {
          type: 'p',
          text:
            'Esta Política é regida pelas leis brasileiras. Fica eleito o foro da comarca de ' +
            `${COMPANY.jurisdiction} para dirimir eventuais controvérsias, sem prejuízo do foro de domicílio ` +
            'do consumidor, quando aplicável.',
        },
      ],
    },
  ],
};
